<!--  -->
<template>
  <div class="send_box">
    <div class="selectr_box">
      <div class="select_small search_box">
        <el-select v-model="pageIfonlist.platform_id" filterable placeholder="请选择平台">
          <el-option
            v-for="item in accoutarr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-select v-model="pageIfonlist.onlyMe" placeholder="请选择">
          <el-option
            v-for="item in accountarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-input v-model="pageIfonlist.timing_push_articles_template_no" placeholder="请输入群发编号" style="width:250px;" />
        <el-input v-model="pageIfonlist.title" placeholder="请输入标题" style="width:250px;" />
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="reast">重置</el-button>
      </div>

      <div style="text-align:right">
        <el-button type="success" icon="el-icon-plus" @click="newlyadded">新增推送</el-button>
      </div>
    </div>

    <div class="add_box">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="title"
          label="标题"
          width="150"
          align="center"
        />
        <el-table-column
          prop="timing_push_articles_template_no"
          label="群发编号"
          width="180"
          align="center"
        />
        <el-table-column
          prop="articles_template_name"
          label="模板名称"
          width="250"
          align="center"
        />
        <el-table-column
          prop="platform_name"
          label="平台名称"
          width="80"
          align="center"
        />
        <el-table-column
          prop="send_time_text"
          label="发送时间"
          width="160"
          align="center"
        />
        <!-- <el-table-column
          prop="statusText"
          label="公众号"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.account_names">
              <el-tag
                v-for="(itemr,index) in scope.row.account_names.slice(0, 4)"
                :key="index"
                style="margin:5px 10px 0px 0px"
              >{{ itemr }}</el-tag>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="tag_name"
          label="标签组"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <!-- <div v-if="scope.row.account_names"> -->
            <el-tag
              v-for="(itemr,index) in scope.row.tag_group_names"
              :key="index"
              style="margin:5px 10px 0px 0px"
            >{{ itemr }}</el-tag>
            <!-- </div> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="created_at_text"
          label="发送群体"
          width="350"
          align="center"
        >
          <template slot-scope="scope">
            <div v-html="scope.row.user_wheres_text" />
          </template>
        </el-table-column>
        <el-table-column
          prop="timing_del"
          label="定时删除天数"
          align="center"
          width="80"
        />
        <el-table-column
          prop="to_all_text"
          label="推送方式"
          align="center"
          width="150"
        />
        <el-table-column
          prop="real_name"
          label="创建人"
          width="80"
          align="center"
        />
        <el-table-column
          prop="created_at_text"
          label="创建时间"
          width="160"
          align="center"
        />
        <!-- <el-table-column
          prop="created_at_text"
          label="互动时间"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.created_at_text }}</div>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="status_text"
          label="状态"
          align="center"
          width="130"
        >
          <template slot-scope="scope">
            <i v-if="scope.row.status == 1" class="el-icon-success defaultrse" />
            <i v-if="scope.row.status == 2" class="el-icon-success defaultr" />
            <i v-if="scope.row.status == 3" class="el-icon-warning" />
            {{ scope.row.status_text }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          min-width="150"
        >
          <!-- slot-scope="scope" -->
          <template slot-scope="scope">
            <el-button v-if="scope.row.status == 1" type="danger" size="mini" @click="stoppush(scope.row.id)">停止推送</el-button>
            <!-- <el-button type="primary" size="mini" @click="look(scope.row.accountNames)">查看推送所有公众号</el-button> -->
            <el-button v-if="scope.row.status == 2" type="primary" size="mini" @click="viewresults(scope.row)">查看发送结果</el-button>
            <el-button type="warning" size="mini" style="margin-top:10px" @click="lookaccount(scope.row)">查看公众号</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :current-page="pageIfonlist.page"
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
      <el-dialog
        title="查看推送所有公众号"
        :visible.sync="dialogVisible"
        :destroy-on-close="true"
      >
        <timingtempdialog ref="dasaccoumt" />
      </el-dialog>
      <el-dialog
        title="查看发送结果"
        :visible.sync="dialogVisibleviewresults"
        :destroy-on-close="true"
      >
        <results ref="viewresultsbox" />
      </el-dialog>
      <el-dialog
        title="查看公众号列表"
        :visible.sync="accoutlistview"
        :destroy-on-close="true"
      >
        <accoutlist ref="accoutlistbox" @updata="updata" />
      </el-dialog>
    </div>

  </div>
</template>

<script>
import { massdispatchlist, sttyow, strategyPlatform } from '@/api/sourceMaterial.js'
import timingtempdialog from './components/timingtempdialog.vue'
import results from './components/results.vue'
import accoutlist from './components/accoutlist.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    timingtempdialog,
    PaginationRight,
    results,
    accoutlist
  },
  data() {
    return {
      tableData: [],
      total: null, // 总页数
      pageIfonlist: {
        page: 1,
        pageSize: 10,
        platform_id: null,
        onlyMe: 2,
        timing_push_articles_template_no: null,
        title: null
      },
      accountarr: [{
        value: 1,
        label: '查看组内推送'
      }, {
        value: 2,
        label: '我创建的推送'
      }],
      dialogVisible: false,
      dialogVisibleviewresults: false,
      accoutlistview: false,
      accoutarr: []
    }
  },
  activated() {
    this.getlistw()
  },
  created() {
    this.getstrategyplatform()
    this.getlistw()
  },
  mounted() {

  },
  methods: {
    search() {
      this.pageIfonlist.page = 1
      this.getlistw()
    },
    reast() {
      this.pageIfonlist = {
        page: 1,
        pageSize: 10,
        platform_id: null,
        onlyMe: 2,
        timing_push_articles_template_no: null
      }
      this.getlistw()
    },
    // 获取推送列表
    async getlistw() {
      const data = await massdispatchlist(this.pageIfonlist)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 获取平台
    async getstrategyplatform() {
      const data = await strategyPlatform()
      this.accoutarr = data.data.list
    },
    // 新增推送
    newlyadded() {
      this.$router.push({
        path: '/massdispatch/index'
      })
    },
    look(item) {
      this.dialogVisible = true
      // setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
      //   this.$refs.dasaccoumt.send(item)
      // }, 100)
      this.$nextTick(() => {
        this.$refs.dasaccoumt.send(item)
      })
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfonlist.pageSize = e
      this.getlistw()
    },
    fetchCurrentPage(e) {
      this.pageIfonlist.page = e
      this.getlistw()
    },
    stoppush(id) {
      this.$confirm('确定停止推送吗？是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        sttyow({
          id: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '停止成功!'
          })
          this.getlistw()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    // 查看结果
    viewresults(item) {
      this.dialogVisibleviewresults = true
      this.$nextTick(() => {
        this.$refs.viewresultsbox.send(item.id)
      })
      console.log('item', item)
    },
    lookaccount(item) {
      this.accoutlistview = true
      this.$nextTick(() => {
        this.$refs.accoutlistbox.send(item.id, item)
      })
    },
    updata() {
      this.getlistw()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.send_box{
  padding: 20px;
}
.add_box{
  margin-top: 20px;
}
.defaultrse{
  color: #E6A23C;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.fasrw{
  color: #409EFF;
}
.selectr_box{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  justify-content: space-between;
}
.select_small{
  display: flex;
  align-items: center;
}
</style>
